import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';

export const payTypes = {hourly: 'Hourly rate', salary: 'Salary', 'per-shift': 'Per shift', mixed: 'Mixed', unknown: 'Unknown pay type'};
const calendarDay = new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'});
const differentDay = (value, scheduled) => {
  if (!value || !scheduled) return false;
  const date = new Date(value);
  const scheduledDate = new Date(scheduled);
  return Number.isFinite(date.getTime()) && Number.isFinite(scheduledDate.getTime()) &&
    calendarDay.format(date) !== calendarDay.format(scheduledDate);
};
const dateTime = (value, includeDate) => {
  const date = value ? new Date(value) : null;
  if (!date || !Number.isFinite(date.getTime())) return '—';
  return <>
    {includeDate && <>{new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/London', day: 'numeric', month: 'short'}).format(date)}{' '}</>}
    <strong>{new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false}).format(date)}</strong>
  </>;
};
const times = (start, end, includeDate = false, includeEndDate = includeDate) => <>{dateTime(start, includeDate)}<br/>{dateTime(end, includeEndDate)}</>;

export default function ShiftTable({shifts, name, issueLabels}) {
  return <TableContainer>
    <Table size="small" aria-label={name}>
      <TableHead><TableRow>
        <TableCell>Employee</TableCell><TableCell>Scheduled</TableCell>
        <TableCell>Clocked</TableCell><TableCell>Approved</TableCell>{issueLabels && <TableCell>Issues</TableCell>}
      </TableRow></TableHead>
      <TableBody>{shifts.map((shift, index) => <TableRow key={shift.shiftId || shift.plandayShiftId || index}>
        <TableCell component="th" scope="row" title={`Shift ${shift.plandayShiftId ?? shift.shiftId ?? 'unknown'}`}>
          {shift.employee?.replace(/^Planday employee (\d+)$/, 'Employee $1') || 'Unknown employee'}
          <Typography variant="body2" color="text.secondary">{payTypes[shift.payType] || payTypes.unknown}</Typography>
        </TableCell>
        <TableCell>{times(shift.startTime, shift.endTime, true)}</TableCell>
        <TableCell>{times(shift.clockInTime, shift.clockOutTime,
          differentDay(shift.clockInTime, shift.startTime), differentDay(shift.clockOutTime, shift.endTime))}</TableCell>
        <TableCell>{times(shift.approvedStart, shift.approvedEnd)}</TableCell>
        {issueLabels && <TableCell>{shift.problems.map(problem => <div key={problem}>{issueLabels[problem] || problem}</div>)}</TableCell>}
      </TableRow>)}</TableBody>
    </Table>
  </TableContainer>;
}
